<div class="cg-dialog">
  <button
    cignaButton="link inline no-underline"
    class="cg-dialog__close"
    (click)="dialogRef.close()"
  >
    Close
    <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
  </button>

  <h2 class="cg-dialog__header">
    <span *ngIf="data.hasWam">Website Access Manager</span>
    <span *ngIf="!data.hasWam">TIN's access has not been activated</span>
  </h2>

  <mat-dialog-content>
    <ng-container *ngIf="data.hasWam">
      <p class="margin-top0">
        The
        <a
          target="resourcesWindow"
          [href]="
            '/resourceLibrary/behavioralResources/websiteAccessManagers'
              | resourceLink: { secure: false, targetApp: 'evernorth' }
              | async
          "
          >website access manager</a
        >(s) for your organization are responsible for assigning the appropriate
        access and entitlements to new users.
      </p>

      <p>
        Website access managers receive notification when a new user registers.
        Once a website access manager approves the request, immediate access
        will be granted to all of the entitlements they delegate (e.g. patient
        search, claim search, reports, etc.).
      </p>

      <h4>Frequently asked questions</h4>

      <div class="cg-margin-top-md">
        <cigna-collapsible-item
          [expanded]="false"
          headerText="What is a website access manager?"
        >
          <p>
            Each Taxpayer Identification Number (TIN) registered on the
            Evernorth Behavioral Professionals website (Provider.Evernorth.com)
            is required to assign at least one, and up to 15, user(s) as the
            website access manager(s). The website access manager(s) oversees
            registration for and grants the appropriate level of access to the
            website.
          </p>

          <p>Website access managers have three key responsibilities:</p>

          <ul>
            <li>
              Obtain access and approve new users in your group for
              Provider.Evernorth.com.
            </li>
            <li>Assign or modify user’s entitlements, or functions.</li>
            <li>Remove access for users who no longer need it.</li>
          </ul>
        </cigna-collapsible-item>
      </div>

      <div class="cg-margin-top-md">
        <cigna-collapsible-item
          [expanded]="false"
          headerText="What if I don't know who my website access manager is?"
        >
          <p>
            If you do not know who in your organization is the website access
            manager, then please call our internet customer service advocates at
            888.736.7499 for assistance.
          </p>
        </cigna-collapsible-item>
      </div>
    </ng-container>

    <ng-container *ngIf="!data.hasWam">
      <p class="margin-top0">
        When a user registers for a TIN that does not have an assigned
        <a
          target="resourcesWindow"
          [href]="
            '/resourceLibrary/behavioralResources/websiteAccessManagers'
              | resourceLink: { secure: false, targetApp: 'evernorth' }
              | async
          "
          >website access manager</a
        >, Cigna's Internet Customer Service Team will perform an outreach to
        identify a website access manager.
      </p>

      <h4>Frequently asked questions</h4>

      <div class="cg-margin-top-md">
        <cigna-collapsible-item
          [expanded]="false"
          headerText="How long will it take to receive an outreach?"
        >
          <p>
            This process may take up to 10 days. If you registered more than 10
            days ago and your TIN still doesn't have an assigned website access
            manager on file, please call our Internet Customer Service Team at
            888.736.7499.
          </p>
        </cigna-collapsible-item>
      </div>
    </ng-container>
  </mat-dialog-content>
</div>
